import { createContext, useEffect, useState } from "react";
import { tableWidth } from "../data/constants";

// const defaultSettings = {
//   strictMode: false,
//   showFieldSummary: true,
//   showGrid: true,
//   mode: "light",
//   autosave: false,
//   panning: true,
//   showCardinality: true,
//   showRelationshipLabels: true,
//   tableWidth: tableWidth,
//   showDebugCoordinates: false,
// };

const defaultSettings = {
  strictMode: true,
  showFieldSummary: true,
  showGrid: true,
  mode: "light",
  autosave: false,
  panning: true,
  showCardinality: true,
  showRelationshipLabels: true,
  tableWidth: tableWidth,
  showDebugCoordinates: false,
};

export const SettingsContext = createContext(defaultSettings);

export default function SettingsContextProvider({ children }) {
  const [settings, setSettings] = useState(defaultSettings);

  useEffect(() => {
    const settings = localStorage.getItem("settings");
    if (settings) {
      setSettings(JSON.parse(settings));
    } 
  }, []);

  useEffect(() => {
    localStorage.setItem("settings", JSON.stringify(settings));
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}
